import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
import { useLanguage } from '../hooks/useLanguage';
import { translations } from '../i18n/translations';
export function NavBar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    language,
    toggleLanguage
  } = useLanguage();
  const t = translations[language].nav;
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: t.about,
    href: '#about'
  }, {
    name: t.services,
    href: '#services'
  }, {
    name: t.skills,
    href: '#skills'
  }, {
    name: t.projects,
    href: '#projects'
  }, {
    name: t.clients,
    href: '#clients'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#050510]/90 backdrop-blur-md border-b border-white/5 py-3' : 'bg-transparent py-5'}`} data-id="element-156">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-157">
        <div className="flex items-center justify-between" data-id="element-158">
          {/* Logo */}
          <a href="#" className="flex-shrink-0 group" data-id="element-159">
            <img src="https://cdn.magicpatterns.com/uploads/nxbnYajbW8aAtgkg1f1pXm/WarpWorkLogoAlternative.png" alt="WarpWork Logo" className="h-10 md:h-12 w-auto transition-transform duration-300 group-hover:scale-105" data-id="element-160" />
          </a>

          {/* Desktop Nav — visible at lg (1024px) and above */}
          <div className="hidden lg:flex items-center space-x-6" data-id="element-161">
            {navLinks.map(link => <a key={link.href} href={link.href} className="text-sm font-medium text-gray-300 hover:text-[#00f5a0] transition-colors relative group whitespace-nowrap" data-id="element-162">
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#00f5a0] transition-all duration-300 group-hover:w-full" data-id="element-163"></span>
              </a>)}

            {/* Language Toggle */}
            <button onClick={toggleLanguage} className="flex items-center bg-white/5 border border-white/10 rounded-full p-0.5 cursor-pointer hover:bg-white/10 transition-colors flex-shrink-0" aria-label="Toggle language" data-id="element-164">
              <span className={`px-2.5 py-0.5 text-xs font-bold rounded-full transition-all ${language === 'en' ? 'bg-gradient-to-r from-[#1a4fd6] to-[#00c9a7] text-white' : 'text-gray-400'}`} data-id="element-165">
                EN
              </span>
              <span className={`px-2.5 py-0.5 text-xs font-bold rounded-full transition-all ${language === 'fr' ? 'bg-gradient-to-r from-[#1a4fd6] to-[#00c9a7] text-white' : 'text-gray-400'}`} data-id="element-166">
                FR
              </span>
            </button>

            <Button variant="primary" size="sm" onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-167">
              {t.hireMe}
            </Button>
          </div>

          {/* Mobile/Tablet Menu — visible below lg */}
          <div className="lg:hidden flex items-center gap-3" data-id="element-168">
            {/* Language Toggle */}
            <button onClick={toggleLanguage} className="flex items-center bg-white/5 border border-white/10 rounded-full p-0.5 cursor-pointer hover:bg-white/10 transition-colors" aria-label="Toggle language" data-id="element-169">
              <span className={`px-2 py-0.5 text-xs font-bold rounded-full transition-all ${language === 'en' ? 'bg-gradient-to-r from-[#1a4fd6] to-[#00c9a7] text-white' : 'text-gray-400'}`} data-id="element-170">
                EN
              </span>
              <span className={`px-2 py-0.5 text-xs font-bold rounded-full transition-all ${language === 'fr' ? 'bg-gradient-to-r from-[#1a4fd6] to-[#00c9a7] text-white' : 'text-gray-400'}`} data-id="element-171">
                FR
              </span>
            </button>

            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-gray-300 hover:text-white p-2" data-id="element-172">
              {isMobileMenuOpen ? <X size={24} data-id="element-173" /> : <Menu size={24} data-id="element-174" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="lg:hidden bg-[#050510] border-b border-white/10 absolute w-full" data-id="element-175">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-176">
            {navLinks.map(link => <a key={link.href} href={link.href} className="block px-3 py-2 text-base font-medium text-gray-300 hover:text-[#00f5a0] hover:bg-white/5 rounded-md" onClick={() => setIsMobileMenuOpen(false)} data-id="element-177">
                {link.name}
              </a>)}
            <div className="pt-4" data-id="element-178">
              <Button className="w-full" variant="outline" onClick={() => {
            setIsMobileMenuOpen(false);
            document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-179">
                {t.hireMe}
              </Button>
            </div>
          </div>
        </div>}
    </nav>;
}